// Port of api/fuel/app/classes/filter/package/users/user/package/general.php
export default {
	run: function(pkg, local, global) {
		var user = global.results[local.id]
		if (!user) return pkg
		return user.to_array(false, global.ownerType === 2 ? global.owner.get_id() : false)
	}
}
